import { ChangeDetectionStrategy, Component } from "@angular/core";
import { BaseModalComponent } from "@ha/ui/common";
import { UntilDestroy } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    templateUrl: "certificate-identifier-hint.component.html",
    styleUrls: ["certificate-identifier-hint.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CertificateIdentifierHintModalComponent extends BaseModalComponent {
    constructor() {
        super();
    }
}
